
import React, { useEffect, useRef, useState } from 'react';
import './CustomizeYourPrinter.css';
import DisplayPrinter from '../../../../../../components/Web/HardwareSignUp/CustomizePrinter/DisplayPrinter/DisplayPrinter';
import Container from "reactstrap/es/Container";
import { useTranslation } from 'react-i18next';
import DisplayMonthlyPageAllowance from '../../../../../../components/Web/HardwareSignUp/CustomizePrinter/DisplaySupplyPlan/MonthlyPageAllowance/DisplayMonthlyPageAllowance';
import DisplayPlanLength from '../../../../../../components/Web/HardwareSignUp/CustomizePrinter/DisplaySupplyPlan/PlanLength/DisplayPlanLength';
import { buildFormattedSelections, filterPlanDetails, getCPPrinterHeader, getEffectivePrinterTypeId, getHardwareFeatureFlags, getPrinterFeatures, getUniquePlanLengths, isCheckoutDisabled } from '../../../../../../utils/HardwareInclusive/HardwareInclusive';
import { useDispatch, useSelector } from 'react-redux';
import DisplayDeviceType from '../../../../../../components/Web/HardwareSignUp/CustomizePrinter/DisplayHardwarePlan/DisplayDeviceType/DisplayDeviceType';
import DisplayTypeOfPrinting from '../../../../../../components/Web/HardwareSignUp/CustomizePrinter/DisplayHardwarePlan/DisplayTypeOfPrinting/DisplayTypeOfPrinting';
import { GetHardwareInclusivePrinterByFeatures } from '../../../../../../actions/HardwareInclusive/HardwareInclusive';
import Loader from '../../../../../../components/shared/loader/Loader';
import { WEB_handleSelectedPlanLocalData, setLocalSessionData } from '../../../../../../utils/Authentication/handleUserSession';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { WebCustomerRoutePaths, WebHardwareInclusiveRoutePath } from '../../../../../../constants/Routes';
import { DEVICE_USAGE_TYPE, LOCALSESSIONDATAKEYS, PRINTER_TYPE, SIGNUPTYPE, tryAgainBtn, TYPE_OF_PRINTING } from '../../../../../../constants/AppConstants';
import { formatNumberOnLocale } from '../../../../../../constants/AppMethod';
import ErrorPage from '../../../../../../components/shared/errorPage/ErrorPage';
import currencies from '../../../../../../constants/CurrencyTypes';
import HardwareSignupHeader from '../HardwareSignupHeader/HardwareSignupHeader';
import PrinterCheckoutBar from '../../../../../../components/Web/HardwareSignUp/CustomizePrinter/PrinterCheckoutBar/PrinterCheckoutBar';
import DisplayHardware from '../../../../../../components/Web/HardwareSignUp/CustomizePrinter/DisplayHardwarePlan/DisplayHardware/DisplayHardware';
import EcoProButton from '../../../../../../components/shared/button/button';

const CustomizeYourPrinter = (props) => {
    const printerFeaturesByPrinterTypeResult = useSelector((state) => state.GetHWPrinterFeaturesByPrinterType)
    const servicePlanHWResult = useSelector((state) => state.GetHWServicePlan)
    const servicePlanNPBResult = useSelector(state => state.ROOTREDUCER_RTK.GetNewPrinterBundleServicePlan);
    const printerByFeaturesResult = useSelector((state) => state.GetHWPrinterByFeatures)
    const hardwareFeatureFlags = getHardwareFeatureFlags(printerFeaturesByPrinterTypeResult?.HW_featureSwitchData);

    const printerFeaturesByTypeResult = printerFeaturesByPrinterTypeResult?.printerFeatures?.printerTypeFeatures
    const allHWServicePlans = servicePlanHWResult?.allServicePlans?.products ?? [];
    const allNPBServicePlans = servicePlanNPBResult?.allServicePlans?.products ?? [];
    const filteredNPBServicePlans = servicePlanNPBResult?.filteredServicePlan?.products ?? [];
    const dispatch = useDispatch()
    const { t } = useTranslation(['translation'])
    const printerTypeId = props?.location?.state?.printerTypeId
    const printerType = props?.location?.state?.printerType
    const defaultImageURL = props?.location?.state?.defaultImageURL
    const defaultDeviceType = hardwareFeatureFlags?.isHWOnly ? DEVICE_USAGE_TYPE.HARDWARE_INCLUSIVE : DEVICE_USAGE_TYPE.NEW_PRINTER_BUNDLE
    const [printerImage, setPrinterImage] = useState([defaultImageURL]);
    const [printerModel, setPrinterModel] = useState()
    const [planLengths, setPlanLengths] = useState([])
    const [selections, setSelections] = useState({
        device: printerType,
        deviceType: defaultDeviceType,
        typeOfPrinting: "",
        hardwarePrinterType: {},
        monthlyPageAllowance: {},
        planLength: "",
    });
    const history = useHistory()
    const isInitialLoad = useRef(true);
    const BonusPages= printerFeaturesByPrinterTypeResult?.HW_featureSwitchData?.BonusPages || false;


    const handleSelectionChange = (key, value) => {
        setSelections(prev => {
            let updated = { ...prev, [key]: value };
            if (key === "deviceType") {
                if (value === prev.deviceType) {
                    return prev;
                }
                setPrinterModel(undefined);
                setPrinterImage([defaultImageURL]);
                return {
                    ...prev,
                    deviceType: value,
                    typeOfPrinting:
                        value === DEVICE_USAGE_TYPE.NEW_PRINTER_BUNDLE
                            ? TYPE_OF_PRINTING.COLOUR
                            : TYPE_OF_PRINTING.MONO,
                    hardwarePrinterType: {},
                    monthlyPageAllowance: {},
                    planLength: ""
                };
            }
            if (key === "typeOfPrinting") {
                const isSameSelection =
                    value === prev.typeOfPrinting;
                if (isSameSelection) {
                    return prev;
                }
                const hardwareFeatures = getPrinterFeatures(
                    printerFeaturesByTypeResult,
                    printerTypeId,
                    updated.deviceType === DEVICE_USAGE_TYPE.HARDWARE_INCLUSIVE
                        ? allHWServicePlans
                        : allNPBServicePlans,
                    updated.deviceType,
                    value
                );

                updated = {
                    ...updated,
                    hardwarePrinterType: hardwareFeatures?.[0] || {},
                    monthlyPageAllowance: {}
                };
                setPrinterModel(undefined);
                setPrinterImage([defaultImageURL]);
            }
            if (key === "hardwarePrinterType" && value?.featureId) {
                const isSameSelection =
                    value.featureId === prev.hardwarePrinterType?.featureId;
                const isDeviceTypeChanged =
                    updated.deviceType !== prev.deviceType;
                if (
                    isSameSelection &&
                    !isDeviceTypeChanged
                ) {
                    return updated;
                }
            }
            return updated;
        });
    };
    useEffect(() => {

        if (!selections.hardwarePrinterType?.featureId) {
            return;
        }

        const effectivePrinterTypeId =
            getEffectivePrinterTypeId(
                printerTypeId,
                selections.typeOfPrinting
            );

        dispatch(
            GetHardwareInclusivePrinterByFeatures(
                effectivePrinterTypeId,
                selections.deviceType,
                selections.hardwarePrinterType.featureId,
                BonusPages
            )
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selections.hardwarePrinterType?.featureId,
        selections.deviceType,
        selections.typeOfPrinting
    ]);
    useEffect(() => {
        if (!printerFeaturesByTypeResult || !printerTypeId) return;
        if (!isInitialLoad.current) return;
        isInitialLoad.current = false;
        let defaultdeviceType;
        let defaulthardwarePrinterType;
        let defaultMonthlyPageAllowance;
        let defaultPlanLength;
        let defaultTypeOfPrinting;
        if (hardwareFeatureFlags?.isHWOnly) {
            defaultdeviceType = DEVICE_USAGE_TYPE.HARDWARE_INCLUSIVE;
        }
        if (hardwareFeatureFlags?.isNPBOnly || hardwareFeatureFlags?.isBothEnabled) {
            defaultdeviceType = DEVICE_USAGE_TYPE.NEW_PRINTER_BUNDLE
            defaultTypeOfPrinting = TYPE_OF_PRINTING.COLOUR
        }
        if (hardwareFeatureFlags?.isHWOnly) {
            defaultTypeOfPrinting = Number(printerTypeId) === PRINTER_TYPE.MONO_LASER ? TYPE_OF_PRINTING.MONO : null;
            const initialServicePlans = allHWServicePlans
            const filteredPlan = filterPlanDetails(initialServicePlans, printerTypeId, selections?.deviceType, "basicPlans", defaultTypeOfPrinting)
            const monthlyPageAllowance = filteredPlan
            defaultMonthlyPageAllowance = monthlyPageAllowance && monthlyPageAllowance.length > 0 ? monthlyPageAllowance[0] : {};
            defaultPlanLength = getUniquePlanLengths(filteredPlan)[0];
        }
        const hardwarePrinterType = getPrinterFeatures(
            printerFeaturesByTypeResult,
            printerTypeId,
            defaultDeviceType === DEVICE_USAGE_TYPE.HARDWARE_INCLUSIVE
                ? allHWServicePlans
                : allNPBServicePlans,
            defaultDeviceType,
            defaultTypeOfPrinting
        )
        defaulthardwarePrinterType = hardwarePrinterType && hardwarePrinterType.length > 0 ? hardwarePrinterType[0] : {};
        setSelections(prevSelections => ({
            ...prevSelections,
            deviceType: defaultdeviceType,
            planLength: defaultPlanLength,
            hardwarePrinterType: defaulthardwarePrinterType,
            monthlyPageAllowance: defaultMonthlyPageAllowance,
        }));
        if (Number(printerTypeId) === PRINTER_TYPE.MONO_LASER) {
            setSelections(prevSelections => ({
                ...prevSelections,
                typeOfPrinting: printerTypeId === PRINTER_TYPE.INKJET ? undefined : defaultTypeOfPrinting
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, printerFeaturesByTypeResult, printerTypeId]);
    useEffect(() => {
        if (printerByFeaturesResult?.success) {
            setPrinterImage(printerByFeaturesResult?.printerModel?.printer?.deviceGallery);
            const model = printerByFeaturesResult?.printerModel?.printer?.printerModel
            setPrinterModel(model)
        }
    }, [printerByFeaturesResult?.success, printerByFeaturesResult?.printerModel?.printer?.deviceGallery, printerByFeaturesResult?.printerModel?.printer?.printerModel]);

    useEffect(() => {
        if (!selections.deviceType) return;
        const updatedServicePlans =
            selections.deviceType === DEVICE_USAGE_TYPE.HARDWARE_INCLUSIVE
                ? allHWServicePlans
                : filteredNPBServicePlans;

        const plansForHardware =
            selections.deviceType === DEVICE_USAGE_TYPE.HARDWARE_INCLUSIVE
                ? (
                    allHWServicePlans
                )
                : (
                    filteredNPBServicePlans?.length
                        ? filteredNPBServicePlans
                        : allNPBServicePlans
                );

        const defaultTypeOfPrinting =
            selections.typeOfPrinting ||
            (
                selections.deviceType === DEVICE_USAGE_TYPE.NEW_PRINTER_BUNDLE
                    ? TYPE_OF_PRINTING.COLOUR
                    : TYPE_OF_PRINTING.MONO
            );
        const filteredPlans = filterPlanDetails(
            updatedServicePlans,
            printerTypeId,
            selections.deviceType,
            "basicPlans",
            defaultTypeOfPrinting
        );
        const uniquePlanLengths =
            getUniquePlanLengths(filteredPlans);
        const hardwareFeatures = getPrinterFeatures(
            printerFeaturesByTypeResult,
            printerTypeId,
            plansForHardware,
            selections.deviceType,
            defaultTypeOfPrinting
        );
        const defaultHardware =
            hardwareFeatures?.[0] || {};
        const defaultPlanLength =
            uniquePlanLengths?.[0] || "";
        setPlanLengths(uniquePlanLengths);
        setSelections(prev => {
            const matchedHardware =
                prev.hardwarePrinterType?.featureId
                    ? prev.hardwarePrinterType
                    : defaultHardware;

            const matchedMonthly =
                selections.deviceType === DEVICE_USAGE_TYPE.HARDWARE_INCLUSIVE
                    ? (
                        filteredPlans.find(
                            plan =>
                                plan.planId ===
                                prev.monthlyPageAllowance?.planId
                        ) || filteredPlans?.[0]
                    )
                    : (
                        filteredPlans.find(
                            plan =>
                                plan.planId ===
                                prev.monthlyPageAllowance?.planId
                        ) || {}
                    );
            return {
                ...prev,
                typeOfPrinting:
                    printerTypeId === PRINTER_TYPE.INKJET
                        ? undefined
                        : (
                            prev.typeOfPrinting ||
                            defaultTypeOfPrinting
                        ),
                hardwarePrinterType: matchedHardware,
                monthlyPageAllowance: matchedMonthly,
                planLength:
                    selections.deviceType === DEVICE_USAGE_TYPE.HARDWARE_INCLUSIVE
                        ? defaultPlanLength
                        : "",
            };
        });
        
        if (
            selections.deviceType ===
            DEVICE_USAGE_TYPE.NEW_PRINTER_BUNDLE &&
            !selections.hardwarePrinterType?.featureId
        ) {
            setPrinterModel(undefined);
            setPrinterImage([defaultImageURL]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selections.deviceType,
        printerFeaturesByTypeResult,
        allNPBServicePlans,
        allHWServicePlans,
        dispatch,
        printerTypeId,
        defaultImageURL,
        filteredNPBServicePlans
    ]);
    const handleCheckout = () => {
        const selectedPlanDetails = selections?.monthlyPageAllowance
        const basePlanAndHWPlan = { ...selectedPlanDetails, 'HWPlans': selections?.hardwarePrinterType };
        WEB_handleSelectedPlanLocalData("Set", basePlanAndHWPlan);
        setLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_MODEL, printerModel);
        setLocalSessionData(LOCALSESSIONDATAKEYS.CURRENCY, selectedPlanDetails?.currency);
        setLocalSessionData(LOCALSESSIONDATAKEYS.SIGNUP_TYPE, SIGNUPTYPE.HARDWARE_INCLUSIVE);
        history.push({ pathname: WebCustomerRoutePaths.WEB_REDIRECT, state: { 'signupType': SIGNUPTYPE.HARDWARE_INCLUSIVE } });
    }
    if (!printerFeaturesByPrinterTypeResult.success) {
        return <ErrorPage errorInfo={t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.ERROR_PRINTER_TYPE_NOT_SELECTED")} showTryAgain={tryAgainBtn.SHOW} to={`${WebHardwareInclusiveRoutePath.SELECT_PRINTER}`}></ErrorPage>
    }
    return (
        <>
            <HardwareSignupHeader />
            <div className='customize-printer-header'>{getCPPrinterHeader(printerTypeId)}</div>
            <Container className='customize-printer-variable-width'>
                {(printerByFeaturesResult?.loading || servicePlanHWResult?.loading || servicePlanNPBResult?.newPBServicePlan_loading) &&
                    <div className={`loader-overlay-wrapper`}>
                        <Loader setOverlay={false} isHarwareInclusive={true}></Loader>
                    </div>}
                <section className='customize-printer1'>
                    <DisplayPrinter
                        printerModel={printerModel}
                        printerTypeId={printerTypeId}
                        printerImage={printerImage}
                        defaultPrinterImage={printerByFeaturesResult?.printerModel?.printer?.deviceImageUrl}
                        cName="flex-column"
                    ></DisplayPrinter>
                    <div className='customize-printer-features-wrapper1'>
                        <header className='customize-printer-header-wrapper'>
                            <div className='customize-printer-subheader'>{t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.SUB_HEADER")}</div>
                        </header>
                        <div className='cp-printer-feature-wrapper'>
                            <DisplayDeviceType
                                handleSelectionChange={(value) => handleSelectionChange('deviceType', value)}
                                selectedData={selections?.deviceType}
                                hardwareFeatureFlags={hardwareFeatureFlags}
                            ></DisplayDeviceType>
                            {(printerTypeId === PRINTER_TYPE.MONO_LASER || printerTypeId === PRINTER_TYPE.COLOUR_LASER) ?
                                <DisplayTypeOfPrinting
                                    handleSelectionChange={(value) => handleSelectionChange('typeOfPrinting', value)}
                                    selectedData={selections}
                                ></DisplayTypeOfPrinting> : null}
                            <DisplayHardware
                                printerFeatures={getPrinterFeatures(printerFeaturesByTypeResult, printerTypeId, selections?.deviceType === DEVICE_USAGE_TYPE.HARDWARE_INCLUSIVE
                                    ? allHWServicePlans
                                    : allNPBServicePlans, selections?.deviceType, selections?.typeOfPrinting)}
                                handleSelectionChange={(value) => handleSelectionChange('hardwarePrinterType', value)}
                                selectedData={selections?.hardwarePrinterType}
                                selectedDeviceType={selections?.deviceType}
                            ></DisplayHardware>
                        </div>
                        <div className='customize-printer-supply-plan'>
                            <DisplayMonthlyPageAllowance
                                handleSelectionChange={(value) => handleSelectionChange('monthlyPageAllowance', value)}
                                selectedData={selections.monthlyPageAllowance}
                                servicePlans={filterPlanDetails(
                                    selections?.deviceType === DEVICE_USAGE_TYPE.HARDWARE_INCLUSIVE
                                        ? allHWServicePlans
                                        : filteredNPBServicePlans,
                                    printerTypeId,
                                    selections?.deviceType,
                                    "basicPlans",
                                    selections?.typeOfPrinting
                                )}                            ></DisplayMonthlyPageAllowance>
                            {selections?.deviceType === DEVICE_USAGE_TYPE.HARDWARE_INCLUSIVE &&
                                <DisplayPlanLength
                                    handleSelectionChange={(value) => handleSelectionChange('planLength', value)}
                                    selectedData={selections.planLength}
                                    planLengths={planLengths}
                                ></DisplayPlanLength>}
                        </div>
                        {!isCheckoutDisabled(selections, printerTypeId) &&
                            <DisplayPrinter
                                printerModel={printerModel}
                                printerTypeId={printerTypeId}
                                printerImage={printerImage}
                                defaultPrinterImage={printerByFeaturesResult?.printerModel?.printer?.deviceImageUrl}
                                cName="flex-row"
                            ></DisplayPrinter>
                        }
                        <EcoProButton
                            cname="pcb-checkout"
                            btnID={`1`}
                            onBtnClick={() => handleCheckout()}
                            disabled={isCheckoutDisabled(selections, printerTypeId)}
                        >
                            {isCheckoutDisabled(selections, printerTypeId) ? t("HARDWARE_SIGNUP.BUTTON.CHECKOUT") : t("HARDWARE_SIGNUP.BUTTON.CHECKOUT_RECOMMENDED_MODEL")}
                        </EcoProButton>
                    </div>
                </section>
            </Container>
            <PrinterCheckoutBar
                printerTypeId={printerTypeId}
                monthlyPaymentPrice={formatNumberOnLocale(selections?.monthlyPageAllowance?.price, currencies[selections?.hardwarePrinterType?.currency]?.code)}
                dueTodayPrice={formatNumberOnLocale(selections?.hardwarePrinterType?.discountedPrice, currencies[selections?.hardwarePrinterType?.currency]?.code)}
                hardwareFeatureFlags={hardwareFeatureFlags}
                formattedSelections={buildFormattedSelections(selections, printerTypeId, hardwareFeatureFlags)}
                disabled={isCheckoutDisabled(selections, printerTypeId)}
                handleCheckout={handleCheckout}
            ></PrinterCheckoutBar>
        </>
    );
};
export default CustomizeYourPrinter;
